import { ReactNode } from "react";
import styles from "./TasksSpacer.module.css";

/** The `TasksSpacer` component properties. */
export interface TasksSpacerProps {

  /** The component children. */
  readonly children: ReactNode;
}

/** Component which applies padding to its bottom to account for the tasks flyout visibility. */
export const TasksSpacer = (props: TasksSpacerProps): ReactNode => {
  const { children } = props;

  return (
    <div className={styles.root}>{children}</div>
  );
};
